export default "__VITE_ASSET__bddf7cb0__"